// Workspace constants and enums

export const SYSTEM_WORKSPACE_ID = '00000000-0000-0000-0000-000000000001';

export enum WorkspaceRole {
  ADMIN = 'admin',
  EDITOR = 'editor',
  VIEWER = 'viewer'
}

export enum DatasetVisibility {
  PUBLIC = 'public',
  PRIVATE = 'private',
  LINK = 'link'
}

export enum PermissionLevel {
  READ = 'read',
  EDIT = 'edit'
}

// Type definitions for workspace-related data
export interface Workspace {
  id: string;
  name: string;
  description: string | null;
  billing_email: string;
  created_at: string;
  updated_at: string;
}

export interface WorkspaceMember {
  id: string;
  workspace_id: string;
  user_id: string;
  role: WorkspaceRole;
  created_at: string;
}

export interface WorkspaceWithMembers extends Workspace {
  members: WorkspaceMember[];
}

// Helper functions for role checks
export const isWorkspaceAdmin = (role: WorkspaceRole): boolean => {
  return role === WorkspaceRole.ADMIN;
};

export const isWorkspaceEditor = (role: WorkspaceRole): boolean => {
  return role === WorkspaceRole.ADMIN || role === WorkspaceRole.EDITOR;
};

export const canEditDatasets = (role: WorkspaceRole): boolean => {
  return role === WorkspaceRole.ADMIN || role === WorkspaceRole.EDITOR;
};

export const canManageWorkspace = (role: WorkspaceRole): boolean => {
  return role === WorkspaceRole.ADMIN;
};

export const canManageMembers = (role: WorkspaceRole): boolean => {
  return role === WorkspaceRole.ADMIN;
};

// Billing-related helpers
export const isBillableRole = (role: WorkspaceRole): boolean => {
  return role === WorkspaceRole.ADMIN || role === WorkspaceRole.EDITOR;
}; 